import { FaCar } from 'react-icons/fa6';
import { images } from '../constants';

const pricing = [
    {
        id: 1,
        image: images.plan1,
        icon: <FaCar />,
        title: 'Basic Plan',
        content: 'For Budget Buyers',
        price: 199.99,
        list: [
            'Basic Warranty',
            '1 Free Service',
            'Roadside Assistance',
            'Car Wash Discount',
            'Standard Support',
        ],
    },
    {  
        id: 2, 
        image: images.plan2,
        icon: <FaCar />,
        title: 'Standard Plan',
        content: 'For Regular',
        price: 299.99,
        list: [
            'Extended Warranty',
            '3 Free Services',
            'Premium Roadside Assistance',
            'Car Wash Subscription',
            'Priority Support',
        ],
    },
    {  
        id: 3,
        image: images.plan3,
        icon: <FaCar />,
        title: 'Premium Plan',
        content: 'For Enthusiasts',
        price: 499.99,
        list: [
            'Comprehensive Warranty',
            'Unlimited Free Services',
            '24/7 Roadside Assistance',
            'Complimentary Car Wash',
            'Dedicated Support',
        ],
    },
];

export default pricing;